// extracted by mini-css-extract-plugin
export var button = "cta-button-module--button--b3dd1";
export var buttonDarkmode = "cta-button-module--button--darkmode--6b653";
export var buttonDisabled = "cta-button-module--button--disabled--04de5";
export var buttonFullWidth = "cta-button-module--button--full-width--f616c";
export var buttonLoading = "cta-button-module--button--loading--e9d47";
export var buttonPrimary = "cta-button-module--button--primary--8103e";
export var buttonPrimarySmall = "cta-button-module--button--primary-small--dae96";
export var buttonSecondary = "cta-button-module--button--secondary--b2a81";
export var buttonSmall = "cta-button-module--button--small--d2502";
export var buttonTertiary = "cta-button-module--button--tertiary--11847";
export var button__child = "cta-button-module--button__child--bc646";
export var button__loadingIcon = "cta-button-module--button__loading-icon--85ee4";
export var ctaButton__icon = "cta-button-module--cta-button__icon--aa4d8";
export var grid = "cta-button-module--grid--9a690";
export var gridWithRowGap = "cta-button-module--grid--with-row-gap--fbe3e";
export var maxWidthContainer = "cta-button-module--max-width-container--fece2";
export var mt0 = "cta-button-module--mt-0--00100";
export var mt1 = "cta-button-module--mt-1--81f43";
export var mt2 = "cta-button-module--mt-2--11f00";
export var mt3 = "cta-button-module--mt-3--56ace";
export var mt4 = "cta-button-module--mt-4--795cd";
export var mt5 = "cta-button-module--mt-5--54b06";
export var mt6 = "cta-button-module--mt-6--eebcf";
export var removeVisuallyHidden = "cta-button-module--remove-visually-hidden--e02d2";
export var visuallyHidden = "cta-button-module--visually-hidden--68776";
export var widgetBase = "cta-button-module--widget-base--b5e95";